import { createContext, useContext } from "react";

export const DrawContext = createContext(null);

export const useDraw = () => {
  const draw = useContext(DrawContext);

  return draw;
};
